import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAppState from '../../AppStore';
import InfoBox from '../../components/infoBox/InfoBox';

const ResetNotification = () => {
  const { t } = useTranslation('agisviewer');
  const displayResetNotification = useAppState((state) => state.displayResetNotification);
  const unsetResetNotification = useAppState((state) => state.unsetResetNotification);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (displayResetNotification) {
      timer = setTimeout(() => {
        unsetResetNotification();
      }, 5000);
    }

    return () => clearTimeout(timer);
  }, [displayResetNotification, unsetResetNotification]);

  if (!displayResetNotification) return null;

  return (
    <InfoBox heading={t('reset_notification_title')} onClose={unsetResetNotification}>
      {t('reset_notification')}
    </InfoBox>
  );
};

export default ResetNotification;
